<template>
    <div class="borrowDetailsBox">
        <Box title="设备调配借用审批">
            <div class="equipment box">
                <p class="title">设备信息</p>
                <div class="equipment-details">
                    <img src="@/assets/img/Icon_1.png" @click="showImg(equipment.img)" />
                    <!-- img :src="equipment.img" @click="showImg(equipment.img)" /> -->
                    <div>
                        <div>
                            <p>资产名称：</p>
                            <p>资产编号：</p>
                            <p>规格型号：</p>
                            <p class="ellipsis">资产序列号：</p>
                        </div>
                        <div>
                            <p class="ellipsis">{{equipment.SBMC}}</p>
                            <p class="ellipsis">{{equipment.SBBH}}</p>
                            <p class="ellipsis">{{equipment.SBXH}}</p>
                            <p class="ellipsis">{{equipment.SBXLH}}</p>
                        </div>
                    </div>
                </div>
                <div>
                    <div class="ellipsis">管理科室：{{equipment.GLKS}}</div>
                    <div class="ellipsis">注册证件号：{{equipment.ZCZJH}}</div>
                </div>
            </div>
            <div class="borrow box">
                <p class="title">调配信息</p>
                <Field title="申请单号" :text="equipment.DH" type="text" :readonly="true" />
                <Field title="申请人" :text="equipment.SQRMC" type="text" :readonly="true" />
                <Field title="申请科室" :text="equipment.SQKSMC" type="text" :readonly="true" />
                <Field title="申请日期" :text="equipment.SQRQ" type="text" :readonly="true" />
                <Field title="联系方式" :text="equipment.LXFS" type="text" :readonly="true" />
                <Field title="申请说明" :text="equipment.SQBZYY" type="textarea" :Isdisabled="true" />
            </div>

            <div class="accessories box">
                <p class="title">配件信息</p>
                <div style="color: #666666;" v-if="accessories.length===0">暂无</div>
                <van-checkbox-group v-model="result" disabled checked-color="#4fa69e">
                    <div class="check-box" v-for="(item, index) in accessories">
                        <van-checkbox :name="index" checked-color="#4fa69e">{{item.PJMC}}</van-checkbox>
                        <span>{{item.BZ}}</span>
                        <!-- <input type="text" placeholder="请输入备注" @input="changeAccessories(index)" /> -->
                    </div>
                </van-checkbox-group>
            </div>
            <div class="accessories box">
                <p class="title">审批信息</p>
                <van-radio-group v-model="radio" direction="horizontal">
                    <p style="width: 50%;">审批结果</p>
                    <van-radio :name="1" icon-disabled checked-color="#07c160">通过</van-radio>
                    <van-radio :name="2" icon-disabled checked-color="#07c160">否决</van-radio>
                </van-radio-group>
                <Field title="审批说明" :text="SPBZYY" placeholder ="请填写审批说明"type="textarea" @onMessage='e=>SPBZYY=e'/>
            </div>

        </Box>
        <div class="footer">
            <div class="button" @click="upload">提交审批</div>
        </div>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import {
        Toast,
        Radio,
        RadioGroup,
        Checkbox,
        CheckboxGroup,
        ImagePreview
    } from 'vant'
    import Field from '@/components/field/field'
    export default {
        name: 'DeployBorrowAuditDefault',
        data() {
            return {
                equipment: {}, //    设备信息
                accessories: [], //    配件信息
                result: [], //    选中的配件信息
                showDiaLog: false,
                radio: 1,//审批结果
                SPBZYY:""
            }
        },
        components: {
            Box,
            Field,
            [Radio.name]: Radio,
            [RadioGroup.name]: RadioGroup,
            [Checkbox.name]: Checkbox,
            [CheckboxGroup.name]: CheckboxGroup
        },
        mounted() {
            this.equipment = this.$route.query.Equipment;
            setTimeout(X => {
                this.loadPJDefault();
            }, 500)
        },
        methods: {
            popupInput(value) { //科室搜索框
                if (this.outTime == 0) {
                    this.outTime = setTimeout(() => {
                        this.DepartmentLoad(value);
                    }, 1000)
                } else {
                    clearTimeout(this.outTime)
                    this.outTime = setTimeout(() => {
                        this.DepartmentLoad(value);
                    }, 1000)
                }
            },
            onMessage(value, key) { //  收到表单消息
                if (this.borrow[key] !== undefined) this.borrow[key] = value
            },
            upload() { //提交方法
                this.$get('api/DeployEquipment/ExamineDeployAudit', {
                         SQDH: this.equipment.DH,
                         SHR: this.$UserInfo.UserId,
                         SHBZ: this.radio,
                         SPBZ: this.SPBZYY
                     }).then(result=>{
                     if(result.code===10000) {
                         Toast(result.msg);
                         setTimeout(X => {
                             this.$router.back();
                         }, 500);
                     }else{
                         Toast(result.msg);
                     }
                 })
            },
            showImg(src) { //点击查看图片
                if (src) {
                    ImagePreview([src])
                } else {
                    Toast('没有图片')
                }
            },
            loadPJDefault() { //请求获取配件信息
                this.$get('api/DeployEquipment/GetDeployAuditPJInfo', {
                            DH: this.equipment.DH,
                            JYLB: 'Y'
                    })
                    .then(result => {
                        this.accessories = result;
                        for (let i = 0; i < this.accessories.length; i++) {
                            if (this.accessories[i].SYZT === "Y") {
                                this.result.push(i);
                            }
                        }
                    })
            }
        }
    }
</script>

<style scoped lang="scss">
    .borrowDetailsBox {
        padding-bottom: 120px;
    }

    .box {
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 34px 40px 0;
        box-sizing: border-box;
        margin-bottom: 20px;
    }

    .title {
        color: $TEXT-DARK-COLOR;
        font-size: 34px;
        font-weight: bold;
    }

    .equipment {
        height: 424px;

        img {
            width: 150px;
            height: 150px;
        }

        .equipment-details {
            display: flex;
            margin-top: 24px;

            &>div {
                margin-left: 34px;
                display: flex;

                div {
                    &:first-child {
                        color: #999;
                        line-height: 55px;
                    }

                    &:last-child {
                        color: #333;
                        line-height: 55px;

                        p {
                            width: 280px;
                            font-size: 29px;
                            color: #333;
                        }
                    }
                }
            }
        }

        &>div:last-child {
            display: flex;
            //border-top: 2px solid #F3F3F3;
            margin-top: 20px;

            div {
                flex: 1;
                text-align: left;
                height: 66px;
                line-height: 66px;
                font-size: 29px;
                color: #999;

                &:first-child {
                    //border-right: 2px solid #F3F3F3;
                }
            }
        }
    }

    .accessories {
        .title {
            margin-bottom: 10px;
        }

        .check-box {
            display: flex;
            height: 112px;
            border-bottom: 2px solid #F3F3F3;

            &:last-child {
                border: none
            }

            .van-checkbox {
                flex: 1;
            }
        }
    }

    .borrow {
        .title {
            margin-bottom: 10px;
        }
    }

    .explain {
        input {
            width: 100%;
            text-align: left;
            margin: 20px 0 48px;
        }
    }
    .AuditRemark p{
        font-size:4vw;
    }

    input {
        width: 150px;
        font-size: 29px;
        text-align: center;
        color: #858585;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    textarea {
        font-size: 30px;
        width: 100%;
        border: none;
        margin: 0;
        padding: 20px 0;

        &::-webkit-input-placeholder {
            color: #858585;
        }
    }

    .footer {
        position: fixed;
        bottom: 0;
        width: 100%;
        height: 114px;
        background: $BACKGROUND-COLOR;
        box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.16);
        padding-top: 24px;

        .button {
            width: 690px;
            height: 96px;
            background: $THEME-COLOR;
            border-radius: 8px;
            color: $TEXT-LIGHT-COLOR;
            font-size: 30px;
            text-align: center;
            line-height: 96px;
            margin: auto;
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/DeployBorrowAuditDefault/DeployBorrowAuditDefault.vue